let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fpvAj")).then(() => parcelRequire('8vvws'));